import { Box, Checkbox, Dialog, DialogContent, Divider, FormControlLabel, FormGroup, Grid2, IconButton, Paper, TextField, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { commonCss } from "../../StyleConfig/CommonCss";
import { Clear, Save } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../API/config";
import { axiosPrivate } from "../../axios/axios";
import WorkAtHeight from "./Certificate/WorkAtHeight";

const CertificateSelect = ({handleCloseClick, data, deleteBol, riskData, staffList, setCertificateListOpen, certificateListOpen, handleCertificate}) => {
    const [searchParams,setSearchParams]=useSearchParams()
    const [workAtHeightOpen, setWorkAtHeightOpen] = useState(false);
    const [certificateInfo, setCertificateInfo] = useState({});

    const [certificate,setCertificate]=useState([])
    const [certificateCount,setCertificateCount]=useState({})
    const [selectedCertificate,setSelectedCertificate]=useState({
      ...data,
      companyId:data.companyId,
      workDescription:data.workDescription,
      enableHotWorkCertificate:data.enableHotWorkCertificate&&deleteBol.enableHotWorkCertificate,
      enableConfinedSpaceCertificate:data.enableConfinedSpaceCertificate&&deleteBol.enableConfinedSpaceCertificate,
      enableSystemOverridingCertificate:data.enableSystemOverridingCertificate&&deleteBol.enableSystemOverridingCertificate,
      enableExcavationCertificate:data.enableExcavationCertificate&&deleteBol.enableExcavationCertificate,
      enableIsolationCertificate:data.enableIsolationCertificate&&deleteBol.enableIsolationCertificate,
      enableLiftingAndHoistingCertificate:data.enableLiftingAndHoistingCertificate&&deleteBol.enableLiftingAndHoistingCertificate,
      enableRadiationCertificate:data.enableRadiationCertificate&&deleteBol.enableRadiationCertificate,
      enableWorkAtHeightCertificate:data.enableWorkAtHeightCertificate&&deleteBol.enableWorkAtHeightCertificate,
      hotWorkCertificateCount:0,
      confinedSpaceCertificateCount:0,
      liftingAndHoistingCertificateCount:0,
      radiationCertificateCount:0,
      isolationCertificateCount:0,
      excavationCertificateCount:0,
      systemOverridingCertificateCount:0,
      workAtHeightCertificateCount:0,
      operationalMeasures:data.enableIsolationCertificate?{...data.operationalMeasures}:null,
      formDetail:{
        ...data.formDetail,
        jmsDocuments:data?.formDetail?.isJMSRequired?riskData.jmsDocuments.map(obj => obj.id).toString():data?.formDetail?.jmsDocuments,
        jsaDocuments:data?.formDetail?.isJSARequired?riskData.jsaDocuments.map(obj => obj.id).toString():data?.formDetail?.jsaDocuments,
        classifiedAreaWhere:data.formDetail.classifiedAreaWhere.length!==0?data.formDetail.classifiedAreaWhere.toString():null,
        classifiedAreaWithWhat:data.formDetail.classifiedAreaWithWhat.length!==0?data.formDetail.classifiedAreaWithWhat.toString():null,
        operationalInformationWhat:data.formDetail.operationalInformationWhat.length!==0?data.formDetail.operationalInformationWhat.toString():null,
        additionalPPPEWhere:data.formDetail.additionalPPPEWhere.length!==0?data.formDetail.additionalPPPEWhere.toString():null,
          staffListText: staffList.length !== 0 ? staffList.toString() : null,
      }
    })
 
    const dispatch=useDispatch()

    console.log("staff", staffList)

    const certificateNameList=[
        {
            name:"enableHotWorkCertificate",
            label:"Hot Work",
            countName:"hotWorkCertificateCount"
        },
        {
            name:"enableConfinedSpaceCertificate",
            label:"Confined Space",
            countName:"confinedSpaceCertificateCount"
        },
        {
            name:"enableSystemOverridingCertificate",
            label:"System Overriding",
            countName:"systemOverridingCertificateCount"
        },
        {
            name:"enableExcavationCertificate",
            label:"Excavation",
            countName:"excavationCertificateCount"
        },
        {
            name:"enableIsolationCertificate",
            label:"Isolation",
            countName:"isolationCertificateCount"
        },
        {
            name:"enableLiftingAndHoistingCertificate",
            label:"Lifting & Hoisting",
            countName:"liftingAndHoistingCertificateCount"
        },
        {
            name:"enableRadiationCertificate",
            label:"Radiation",
            countName:"radiationCertificateCount"
        },
        {
            name:"enableWorkAtHeightCertificate",
            label:"Work At Height",
            countName:"workAtHeightCertificateCount"
        },
    ]

    const handleSave=async()=>{
        if(selectedCertificate.enableWorkAtHeightCertificate){
            // Open Work At Height modal directly within this component
            setWorkAtHeightOpen(true);
            setCertificateInfo({});
            return;
        } else if(selectedCertificate.enableHotWorkCertificate||selectedCertificate.enableConfinedSpaceCertificate||selectedCertificate.enableSystemOverridingCertificate||selectedCertificate.enableExcavationCertificate||selectedCertificate.enableIsolationCertificate||selectedCertificate.enableLiftingAndHoistingCertificate||selectedCertificate.enableRadiationCertificate){
       const saveLink=api.PTWForm.saveForm
       const ValidateCertificateApproved=api.PTWForm.ValidateCertificateApproved
       axiosPrivate.get(`${ValidateCertificateApproved}?id=${data.id}&&roleName=${atob(searchParams.get('requestor'))}`).then(res=>{
         const postData={...selectedCertificate,isolationCertificateCount:Number(selectedCertificate.isolationCertificateCount)}
       console.log(postData)
        axiosPrivate.post(`${saveLink}`,postData).then(res=>{
        console.log(res)
        toast.success("Successfully Added")
        handleCloseClick()
       }).catch(e=>{
        toast.error(e.response.data.message)
        console.log(e,"add certificate")
        })
      console.log(res)
       }).catch(e=>{
        console.log(e)
        toast.error(e.response.data.message)
       })
      
      }else{
        toast.error("Please Select Certificate")
      }
    }
    const handleCheckBox=(e,detail)=>{
        
        // if(e.target.checked){
        //     setCertificate([...certificate,detail])
        //     setCertificateCount({...certificateCount,[detail.name]:1})
        //   }else{
        //     setCertificate(certificate.filter(fil=>fil.label!==detail.label))
        //     setCertificateCount({...certificateCount,[detail.name]:0})
        //   }
        console.log({...selectedCertificate,[e.target.name]:e.target.checked,[detail.countName]:detail.countName!=="isolationCertificateCount"?1:e.target.checked?selectedCertificate.isolationCertificateCount:0})
        
        setSelectedCertificate({...selectedCertificate,[e.target.name]:e.target.checked,[detail.countName]:detail.countName!=="isolationCertificateCount"?1:e.target.checked?Number(selectedCertificate.isolationCertificateCount)===0?1:selectedCertificate.isolationCertificateCount:0})
    }
  return (
    <Paper sx={{ background: commonCss.shadeLinearGradient, p: 1.5 }}>
      <Grid2 container>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography  fontWeight={600} color={commonCss.green} sx={{fontSize:"1.3rem"}}>
              Certificate
            </Typography>
            <Box sx={{display:"flex",alignItems:"center",width:"40%",justifyContent:"flex-end",gap:"1rem"}}>
              <IconButton onClick={handleSave}>
                <Save sx={{color:commonCss.red}}/>
              </IconButton>
              <IconButton onClick={handleCloseClick}>
                <Clear sx={{color:commonCss.red}}/>
              </IconButton>
            </Box>
          </Box>
          <Divider sx={{borderColor: commonCss.red, borderWidth: 1,width:"100%"}}/>
        </Grid2>
        <Grid2 size={12}>
        <FormGroup  >
            {certificateNameList.map((typeLevel,i)=>(
              <Fragment key={i}>
                <Box sx={{display:"flex",alignItems:"flex-end"}}>
               <FormControlLabel
               
               sx={{ mt:1.5}}
               control={
               <Checkbox 
               disabled={data[typeLevel.name]}
               checked={selectedCertificate[`${typeLevel.name}`]}
               name={typeLevel.name} 
               sx={{
                "& .MuiSvgIcon-root": {
                   color: commonCss.red,
                 },
                 "&:checked": {
                   color: commonCss.red,
                 },
               }}
               onChange={(e)=>{handleCheckBox(e,typeLevel)}}
             />
               
               } label={typeLevel.label} />
               <TextField
              fullWidth
              type="number"
              variant="outlined"
              size="small"
              slotProps={{
                input:{
                  inputProps: { 
                    max: 3, min: 1
                }
                }
              }}
              
              value={selectedCertificate.isolationCertificateCount}
              onChange={(e)=>{
                const num=Number(e.target.value)
                if (num >= 1 && num <= 3||e.target.value==="") {
                  setSelectedCertificate({...selectedCertificate,isolationCertificateCount:e.target.value})
                 
                }else{
                 
                  toast.error("Isolation Certificate Count should be between 1 to 3")
               
                }
                
              }}
              sx={{
                display:typeLevel.label==="Isolation"?selectedCertificate.enableIsolationCertificate?"default":"none":"none",
                width:"10vw",
                '& .MuiOutlinedInput-root': {
                  backgroundColor: commonCss.inputBackgroundColor, 
                  borderRadius:commonCss.inputBorderRadius
                },
                '& .MuiOutlinedInput-notchedOutline': {
                 borderColor: commonCss.inputBorderColor, 
                },
              }}
              
            />
            </Box>
               </Fragment>
            ))}
          
          </FormGroup>
        </Grid2>

        {/* Work At Height Modal */}
        <Dialog
          open={workAtHeightOpen}
          onClose={() => {
            setWorkAtHeightOpen(false);
          }}
          PaperProps={{
            sx: {
              maxWidth: { xs: "100vw", md: "80vw", lg: "70vw" },
              width: { xs: "100vw", md: "80vw", lg: "70vw" },
              background: commonCss.normalLinearGradient,
              borderRadius: "10px",
            },
          }}
        >
          <DialogContent>
            <WorkAtHeight
              certificateDetail={certificateInfo}
              approvedData={data}
              handleCloseClick={() => {
                setWorkAtHeightOpen(false);
                handleCloseClick();
                if (handleCertificate) {
                  handleCertificate({
                    name: "enableWorkAtHeightCertificate",
                    label: "Work At Height",
                    api: "workAtHeight",
                  });
                }
              }}
            />
          </DialogContent>
        </Dialog>
      </Grid2>
    </Paper>
  );
};

export default CertificateSelect;
